import React from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import SettingsTabsNavigation from "../../../components/Tabs/SettingsTabsNavigation";
import TaskNotificationSettings from "./TaskNotificationSettings";
import ExpirationNotificationSettings from "./SubscriptionExpirationSettings";
import AlertPolicyBuilder from "./AlertPolicyBuilder";
import { getLifecycleTypeName } from "../../../utils/lifecycleUtils";

const route = all_routes;

const NotificationSettings = () => {
  const location = useLocation();
  const pathname = location.pathname;

  let activeTab: "TASK" | "EXPIRATION" | "LEAD" | "PIPELINE" | "DEAL" | "PROPOSAL" | "CONTRACT" = "TASK";
  if (pathname.includes("/notification-settings/expiration")) activeTab = "EXPIRATION";
  else if (pathname.includes("/notification-settings/leads")) activeTab = "LEAD";
  else if (pathname.includes("/notification-settings/pipelines")) activeTab = "PIPELINE";
  else if (pathname.includes("/notification-settings/deals")) activeTab = "DEAL";
  else if (pathname.includes("/notification-settings/proposals")) activeTab = "PROPOSAL";
  else if (pathname.includes("/notification-settings/contracts")) activeTab = "CONTRACT";

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col-sm-4">
              <h4 className="page-title">Settings</h4>
            </div>
            <div className="col-sm-8 text-sm-end">
              <div className="head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body pb-0 pt-2">
            <SettingsTabsNavigation
              activeTab="notification-settings"
              variant="bottom"
              includeIcons={true}
              context="profile"
            />
          </div>
        </div>

        <div className="row">
          {/* Sidebar */}
          <div className="col-xl-3 col-lg-12 theiaStickySidebar">
            <div className="card">
              <div className="card-body">
                <div className="settings-sidebar">
                  <h4 className="fw-semibold mb-3">Notification Settings</h4>
                  <div className="list-group list-group-flush settings-sidebar">
                    <Link
                      to={route.taskNotificationSettings}
                      className={`fw-medium ${activeTab === "TASK" ? "active" : ""}`}
                    >
                      Task Settings
                    </Link>
                    <Link
                      to={route.expirationNotificationSettings}
                      className={`fw-medium ${activeTab === "EXPIRATION" ? "active" : ""}`}
                    >
                      Subscription Expiration
                    </Link>
                    <Link
                      to={route.notificationSettingsLeads}
                      className={`fw-medium ${activeTab === "LEAD" ? "active" : ""}`}
                    >
                      {getLifecycleTypeName("LEAD")}
                    </Link>
                    <Link
                      to={route.notificationSettingsPipelines}
                      className={`fw-medium ${activeTab === "PIPELINE" ? "active" : ""}`}
                    >
                      {getLifecycleTypeName("PIPELINE")}
                    </Link>
                    <Link
                      to={route.notificationSettingsDeals}
                      className={`fw-medium ${activeTab === "DEAL" ? "active" : ""}`}
                    >
                      {getLifecycleTypeName("DEAL")}
                    </Link>
                    <Link
                      to={route.notificationSettingsProposals}
                      className={`fw-medium ${activeTab === "PROPOSAL" ? "active" : ""}`}
                    >
                      {getLifecycleTypeName("PROPOSAL")}
                    </Link>
                    <Link
                      to={route.notificationSettingsContracts}
                      className={`fw-medium ${activeTab === "CONTRACT" ? "active" : ""}`}
                    >
                      {getLifecycleTypeName("CONTRACT")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-xl-9 col-lg-12">
            <div className="card">
              <div className="card-body">
                {activeTab === "TASK" && <TaskNotificationSettings />}
                {activeTab === "EXPIRATION" && <ExpirationNotificationSettings />}
                {activeTab === "LEAD" && <AlertPolicyBuilder entityName={getLifecycleTypeName("LEAD")} />}
                {activeTab === "PIPELINE" && <AlertPolicyBuilder entityName={getLifecycleTypeName("PIPELINE")} />}
                {activeTab === "DEAL" && <AlertPolicyBuilder entityName={getLifecycleTypeName("DEAL")} />}
                {activeTab === "PROPOSAL" && <AlertPolicyBuilder entityName={getLifecycleTypeName("PROPOSAL")} />}
                {activeTab === "CONTRACT" && <AlertPolicyBuilder entityName={getLifecycleTypeName("CONTRACT")} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
